import Request from "./request";
const Comment = "/comment";

export default {
  //评论接口
  async getComment(objectType, objectId) {
    return Request.get(Comment, {
      objectType: objectType,
      objectId: objectId
    });
  },
  async createComment(data) {
    return Request.post(Comment, data);
  },
  async deleteComment(id) {
    return Request.post(Comment, id);
  },
  async getCommentMine(query) {
    return Request.get(`${Comment}/mine`, query);
  }
};
